import { useTranslation } from "react-i18next";
import Button from "../../Button/Button";
import styles from "../TransparentDrawer.module.scss";
import { useVenuesDataStore } from "@/store/useVenuesDataStore";
import { useNavigate, useParams } from "react-router-dom";
import useOnClickFunctions from "../helpers/onClickFunctions";

function ExtraTip() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { restaurantId, tableId } = useParams();
  const { selectedAmount, remainingAmount, setVenuesData } =
    useVenuesDataStore();
  const { handleNavigate } = useOnClickFunctions();
  const extraTipAmount = (selectedAmount * 100 - remainingAmount) / 100;

  const handleSkipTheTip = () => {
    setVenuesData({ selectedAmount: remainingAmount / 100 });
    handleNavigate(
      `/restaurants/${restaurantId}/tables/${tableId}/split-the-bill/confirm-and-pay`,
    );
  };

  return (
    <div className={styles.paymentButtonsGroupWrapper}>
      <Button
        onClick={() => {
          handleNavigate(
            `/restaurants/${restaurantId}/tables/${tableId}/split-the-bill/confirm-and-pay`,
          );
        }}
        label={`${t("transparentDrawer.button.addExtra")} ${extraTipAmount.toFixed(2)} zł ${t(
          "transparentDrawer.button.asTip",
        )}`}
        variant="contained"
        color="primary"
        maxWidth
        mobile={true}
      />
      <Button
        onClick={handleSkipTheTip}
        label={`${t("transparentDrawer.button.payOnly")} ${(remainingAmount / 100).toFixed(2)} zł`}
        variant="contained"
        color="primary"
        maxWidth
        mobile={true}
      />
      <Button
        onClick={() =>
          navigate(
            `/restaurants/${restaurantId}/tables/${tableId}/pay-your-bill`,
          )
        }
        label={t("transparentDrawer.button.cancelSplit")}
        variant="outlined"
        color="primary"
        maxWidth
        mobile={true}
      />
    </div>
  );
}

export default ExtraTip;
